import { useUserSessionStore } from "stores/UserSession.store";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { privatePages } from "./routes";
import { matchPath } from "react-router-dom";

export const PrivateRoute = () => {
  const user = useUserSessionStore(state => state.user);
  const loading = useUserSessionStore(state => state.loading);
  const location = useLocation();

  if (loading && !user) return <></>;

  if (!user) return <Navigate to="/"/>;

  const currentPath = location.pathname;

  const currentRoute = privatePages.find(route => {
    return matchPath({ path: route.path }, currentPath);
  });

  if (!currentRoute || !currentRoute.allowedRoles) return <Outlet/>;

  const userRole = user.role;
  const isRoleAllowed = currentRoute.allowedRoles.includes(userRole);

  if (!isRoleAllowed) {
    return <Navigate to="/"/>;
  }

  return <Outlet/>;
};
